module.exports = require("@mdi/react");